<script setup lang="ts">
import { ProjectHeaderImage, AppBackground } from '@haskoning/vue-component-library'

type Section = {
  title: string
  content: string
  image?: string
  imageAlt?: string
}

defineProps<{
  title: string
  imageSrc?: string
  imageLazySrc?: string
  sections?: Section[]
}>()
</script>

<template>
  <div class="fill-height test">
    <ProjectHeaderImage
      :lazy-src="imageLazySrc || '/header_lazy.jpg'"
      :src="imageSrc || '/header.jpeg'"
    />
    <AppBackground>
      <v-card-title class="title-text">{{ title }}</v-card-title>
      <template v-if="sections && sections.length">
        <div v-for="(section, idx) in sections" :key="idx">
          <div v-if="section.image" class="content-container">
            <div class="content-text">
              <v-card-title
                v-if="section.title"
                :class="idx === 0 ? 'title-text' : 'section-title-text'"
                >{{ section.title }}</v-card-title
              >
              <v-card-text class="body-text">
                <div v-html="section.content"></div>
              </v-card-text>
            </div>
            <img
              class="content-image"
              :src="section.image"
              :alt="section.imageAlt || 'Section image'"
            />
          </div>
          <div v-else>
            <v-card-title
              v-if="section.title"
              :class="idx === 0 ? 'title-text' : 'section-title-text'"
              >{{ section.title }}</v-card-title
            >
            <v-card-text class="body-text">
              <div v-html="section.content"></div>
            </v-card-text>
          </div>
        </div>
      </template>
      <template v-else>
        <v-card-text class="body-text">
          <slot />
        </v-card-text>
      </template>
      <slot name="extra" />
    </AppBackground>
  </div>
</template>

<style scoped>
.content-container {
  display: flex;
  align-items: stretch;
  gap: 20px;
}
.content-image {
  width: 40%;
  height: auto;
  object-fit: cover;
  border-radius: 12px;
  margin-left: 10px;
  margin-right: 10px;
  padding: 5px;
  background: #fff;
}
.content-text {
  flex: 1;
}
.title-text {
  font-family: 'Roboto', Arial, Helvetica, sans-serif;
  font-size: 24px;
  font-weight: 500;
  line-height: 24px;
  margin-bottom: 5px;
}

.section-title-text {
  font-family: 'Roboto', Arial, Helvetica, sans-serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  margin-bottom: 5px;
}

.body-text {
  font-family: 'Roboto', Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}
</style>
